var indexOf = [].indexOf;

angular.module('gym.calendar').controller('ChangeEventsFrequencyCtrl', ["$scope", "$rootScope", "$filter", "$modalInstance", "$timeout", "EditEventService", "EditEventScheduleService", "EventService", "flash", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $rootScope, $filter, $modalInstance, $timeout, EditEventService, EditEventScheduleService, EventService, flash, ConfirmLeaveUnsavedChangesService, params) {
  var getDailySession, getRecurringBookings, gym, updateFrequencyParams;
  gym = $rootScope.gym;
  $scope.event = params.event;
  $scope.eventRepeatIntervalUnits = EditEventService.getEventRepeatIntervalUnits();
  $scope.days = EditEventService.getDays();
  $scope.formParams = {};
  $scope.selectedRepeatOption = null;
  getRecurringBookings = function() {
    var filters;
    filters = {
      event_schedule_id: $scope.event.event_schedule_id
    };
    return EventService.getRecurringBookings(filters).then(function(recurringBookings) {
      return $scope.recurringBookings = recurringBookings;
    });
  };
  getRecurringBookings();
  $scope.recurringBookingsWarningVisible = function() {
    var ref;
    return gym.gym_config.recurring_bookings_feature_enabled && ((ref = $scope.recurringBookings) != null ? ref.length : void 0);
  };
  $scope.frequencyUpdateParams = {
    change_type: 'change_frequency',
    change_attributes: {
      repeat_interval_unit: $scope.event.repeat_interval_unit,
      repeat_interval_number: $scope.event.repeat_interval_number,
      daily_sessions: $scope.event.daily_sessions,
      monthly_repeat_rule: $scope.event.monthly_repeat_rule,
      monthly_repeat_wday: $scope.event.monthly_repeat_wday,
      monthly_repeat_wday_count: $scope.event.monthly_repeat_wday_count
    }
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'frequencyUpdateParams', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  $scope.toggleDay = function(index) {
    EditEventScheduleService.toggleDay($scope.event, $scope.frequencyUpdateParams.change_attributes, index);
    if ($scope.frequencyUpdateParams.change_attributes.daily_sessions[index]) {
      $scope.frequencyUpdateParams.change_attributes.daily_sessions[index][0].editable = true;
    }
    return $scope.validate();
  };
  $scope.addDailySession = function(index) {
    return $scope.frequencyUpdateParams.change_attributes.daily_sessions[index].push(getDailySession());
  };
  $scope.removeSession = function(dayIndex, sessionIndex) {
    $scope.frequencyUpdateParams.change_attributes.daily_sessions[dayIndex].splice(sessionIndex, 1);
    if (!$scope.frequencyUpdateParams.change_attributes.daily_sessions[dayIndex].length) {
      delete $scope.frequencyUpdateParams.change_attributes.daily_sessions[dayIndex];
    }
    return $scope.validate();
  };
  $scope.isDaySelected = function(index) {
    return EditEventScheduleService.isDaySelected($scope.frequencyUpdateParams.change_attributes, index);
  };
  getDailySession = function(startTime = $scope.event.start_time) {
    return angular.extend({
      editable: true
    }, EditEventScheduleService.getDailySession($scope.event, startTime));
  };
  $scope.onDailySessionStartTimeChanged = function(session, day) {
    return angular.extend(session, getDailySession(session.start_at_obj));
  };
  $scope.onDailySessionEndTimeChanged = function(session, day) {
    return EditEventScheduleService.onDailySessionEndTimeChanged(session);
  };
  $scope.parseDailySession = function(session) {
    if (session.start_at && session.end_at) {
      session.start_at_obj = moment(session.start_at, 'h:mma').toDate();
      return session.end_at_obj = moment(session.end_at, 'h:mma').toDate();
    }
  };
  $scope.onIntervalUnitChanged = function() {
    if ($scope.frequencyUpdateParams.change_attributes.repeat_interval_unit === 'week') {
      $scope.frequencyUpdateParams.change_attributes.daily_sessions = $scope.event.daily_sessions;
    } else {
      $scope.frequencyUpdateParams.change_attributes.daily_sessions = void 0;
    }
    if ($scope.frequencyUpdateParams.change_attributes.repeat_interval_unit !== 'month') {
      $scope.frequencyUpdateParams.change_attributes = _.omit($scope.frequencyUpdateParams.change_attributes, ['monthly_repeat_rule', 'monthly_repeat_wday', 'monthly_repeat_wday_count']);
    }
    return $scope.validate();
  };
  $scope.displayCopyWdays = function(days) {
    return days.map(function(day) {
      return $filter('capitalize')($filter('limitTo')($scope.days[day], 3));
    }).join(', ');
  };
  updateFrequencyParams = function(repeatOption, dayOfWeekIndex, weekOccurrence) {
    return $scope.frequencyUpdateParams.change_attributes = angular.extend({}, $scope.frequencyUpdateParams.change_attributes, {
      monthly_repeat_rule: repeatOption,
      monthly_repeat_wday: repeatOption === 'repeat_on_nth_wday_of_month' || repeatOption === 'repeat_on_last_wday_of_month' ? dayOfWeekIndex : null,
      monthly_repeat_wday_count: repeatOption === 'repeat_on_nth_wday_of_month' ? weekOccurrence : null
    });
  };
  $scope.updateRecurrenceOptions = function() {
    var dayOfMonth, dayOfWeekIndex, dayOfWeekName, firstDayOfMonth, lastPossibleDay, lastWeekStart, opt, options, prevSelection, ref, selectedDate, weekOccurrence;
    if (!((ref = $scope.event) != null ? ref.start_at : void 0)) {
      return;
    }
    selectedDate = moment($scope.event.start_at);
    dayOfMonth = selectedDate.date();
    dayOfWeekIndex = selectedDate.day();
    dayOfWeekName = selectedDate.format('dddd');
    firstDayOfMonth = moment(selectedDate).startOf('month');
    weekOccurrence = Math.ceil(dayOfMonth / 7);
    lastPossibleDay = moment(selectedDate).endOf('month').date();
    lastWeekStart = lastPossibleDay - 6;
    options = [
      {
        value: 'repeat_on_nth_day_of_month',
        label: `the ${$filter('ordinal')(dayOfMonth)} day of the month`
      }
    ];
    if (weekOccurrence === 1 || weekOccurrence === 2 || weekOccurrence === 3 || weekOccurrence === 4) {
      options.push({
        value: 'repeat_on_nth_wday_of_month',
        label: `the ${$filter('ordinal')(weekOccurrence)} ${dayOfWeekName} of the month`
      });
    }
    if (dayOfMonth >= lastWeekStart) {
      options.push({
        value: 'repeat_on_last_wday_of_month',
        label: `the last ${dayOfWeekName} of the month`
      });
    }
    prevSelection = $scope.event.selectedRepeatOption || $scope.event.monthly_repeat_rule;
    $scope.recurrenceDropdownOptions = options;
    if (indexOf.call((function() {
      var i, len, results;
      results = [];
      for (i = 0, len = options.length; i < len; i++) {
        opt = options[i];
        results.push(opt.value);
      }
      return results;
    })(), prevSelection) >= 0) {
      $scope.event.selectedRepeatOption = prevSelection;
    } else {
      $scope.event.selectedRepeatOption = options[0].value || $scope.event.monthly_repeat_rule;
    }
    return updateFrequencyParams($scope.event.selectedRepeatOption, dayOfWeekIndex, weekOccurrence);
  };
  $scope.updateRecurrenceOptions();
  $scope.copyDailySessionWdays = $scope.days.map(function(day, index) {
    if (index < 6) {
      return [index + 1];
    } else {
      return [0];
    }
  });
  $scope.isCopyDaySelected = function(dayIndex, copyDay) {
    return EditEventService.isCopyDaySelected(dayIndex, copyDay, $scope.copyDailySessionWdays);
  };
  $scope.toggleCopyDay = function(dayIndex, copyDayIndex) {
    return EditEventService.toggleCopyDay(dayIndex, copyDayIndex, $scope.copyDailySessionWdays);
  };
  $scope.copySession = function(day) {
    return EditEventService.copySession($scope.event, day, $scope.copyDailySessionWdays);
  };
  $scope.validate = function() {
    var isValid;
    isValid = (function() {
      switch ($scope.frequencyUpdateParams.change_attributes.repeat_interval_unit) {
        case 'week':
          return !_.isEmpty($scope.frequencyUpdateParams.change_attributes.daily_sessions);
        default:
          return $scope.frequencyUpdateParams.change_attributes.repeat_interval_number > 0;
      }
    })();
    return $scope.formParams.isInvalid = !isValid;
  };
  $scope.moveSessionTimes = function() {
    $scope.close(true);
    return params.showChangeWeeklySessionTimeForm();
  };
  $scope.isFormReady = function() {
    return !$scope.isLoading && !$scope.formParams.isInvalid;
  };
  return $scope.save = function() {
    $scope.isLoading = true;
    return params.save($scope.frequencyUpdateParams).then(function() {
      return $scope.close(true);
    }, function() {
      return $scope.isLoading = false;
    });
  };
}]);
